import { Box, Typography, useTheme } from "@mui/material";
import Loader from "react-spinners/PulseLoader";
import { tokens } from "../theme";

const Loading = ({ size = 20, label, fullPage }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isLightMode = theme.palette.mode === "light";
  const isDefaultSize = size === 20;
  const isFullPage = fullPage ?? isDefaultSize;

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        ...(isFullPage ? { height: "60vh" } : { py: 1 }),
      }}
    >
      <Loader
        color={isLightMode ? colors.grey[700] : colors.grey[100]}
        size={size}
      />
      {label && (
        <Typography variant="body2" sx={{ color: colors.grey[300] }}>
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default Loading;
